(function() {
  // --- CONFIGURATION ---
  var params = ['utm_source', 'utm_medium', 'utm_campaign'];
  var first_touch_days = 30; // Discovery window
  var last_touch_days = 7;   // Conversion window

  // --- HELPER FUNCTIONS ---
  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  // --- STEP 1: CAPTURE FROM URL ---
  var urlParams = new URLSearchParams(window.location.search);
  var foundNewUtm = false;

  params.forEach(function(p) {
    var val = urlParams.get(p);
    if (val) {
      // 1. Always update "Last" (7-day window)
      setCookie('last_' + p, val, last_touch_days);
      
      // 2. Set "First" ONLY if it doesn't already exist (30-day window)
      if (!getCookie('first_' + p)) {
        setCookie('first_' + p, val, first_touch_days);
      }
      foundNewUtm = true;
    }
  });

  // 3. Set a Timestamp for the VERY first click (30-day window)
  if (foundNewUtm && !getCookie('utm_date')) {
    setCookie('utm_date', new Date().toISOString().split('T')[0], first_touch_days);
  }

  // --- STEP 2: SYNC TO SHOPIFY CART ---
  var attributes = {};
  var keysToSync = [
    'first_utm_source', 'last_utm_source',
    'first_utm_medium', 'last_utm_medium',
    'first_utm_campaign', 'last_utm_campaign',
    'utm_date'
  ];

  var hasData = false;
  keysToSync.forEach(function(key) {
    var value = getCookie(key);
    if (value) {
      attributes[key] = value;
      hasData = true;
    }
  });

  if (hasData) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function(err) {
      console.warn('[Tracking] Cart update failed', err);
    });
  }
})();